import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';

import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/references.actions';
import * as home from '../../../../actions/process.home.actions';

import TextField from '@material-ui/core/TextField';
import Hidden from '@material-ui/core/Hidden';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';
import Menu from '../Menu';
import Presentation from './PresentationTable';

import { BlueTickIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function isOk(field) {
    return field === undefined || field.length < 2;
}

function helperText(field, intl) {
    return field === undefined || field.length === 0
        ? intl.formatMessage({ id: 'required' })
        : field.length < 2
            ? intl.formatMessage({ id: 'min_length_2' })
            : '';
}

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-reference"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}

class Reference extends React.Component {
    state = {
        id: undefined,
        nombre: '',
        presentaciones: [],
    };

    constructor(props) {
        super(props);
        if (props.id) {
            props.loadReference(props.id);
        }
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.reference !== state.reference && props.id !== undefined) {
            state.reference = props.reference;
            state.nombre = props.reference && props.reference.nombre ? props.reference.nombre : '';
            state.presentaciones = props.reference ? props.reference.presentaciones : [];
            return state;
        }

        return null;
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    updateHandle(state) {
        if (this.isCorrect(state)) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        const state = this.state;
        state[event.target.name] = event.target.value;
        this.updateHandle(state);
        this.setState(state);
    };

    isCorrect = (state) => {
        const { nombre, presentaciones } = state;
        return nombre && nombre.length > 1 && presentaciones && presentaciones.length > 0;
    };

    handleSummit = () => {
        const { nombre, presentaciones } = this.state;
        const reference = {
            nombre: nombre,
            presentaciones: presentaciones.map((r) => {
                if (typeof r.id !== 'number') {
                    r.id = undefined;
                }
                return r;
            }),
        };

        if (!this.props.id) {
            this.props
                .addReference(reference)
                .then((r) => {
                    this.props.history.push('/manage/references');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        } else {
            reference.id = this.props.id;
            this.props
                .editReference(reference)
                .then((r) => {
                    this.props.history.push('/manage/references');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    handleClose = () =>{
        this.setState({ error: undefined, errorType: undefined })
    }

    render() {
        const { nombre, presentaciones, error, errorType } = this.state;
        const { intl, id, info, references_is_loading, references_has_errored } = this.props;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '64') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && references_has_errored.hasErrored) {
            return (
                <Error open type={references_has_errored.hasErrored}  message={references_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {references_is_loading && <Loading open opacity />}
                    {error && (
                        <Snackbar
                            open={true}
                            variant={ errorType ? errorType : "error" }
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full bg_white'}>
                        <div className={'flex_full_column padding_bottom_9 height100'}>
                            <div
                                className="flex_full overflow_y_scroll "
                                onScroll={this.handleScroll}
                            >
                                <div className="flex_full_column padding_borders">
                                    <TextField
                                        fullWidth
                                        id={'nombre'}
                                        name={'nombre'}
                                        error={isOk(nombre)}
                                        helperText={helperText(nombre, intl)}
                                        label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                                        className={'flex_full_row'}
                                        value={nombre}
                                        onChange={this.handleChange}
                                        margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="flex_full_column padding_borders">
                                    <Presentation
                                        {...this.props}
                                        data={presentaciones}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Reference.propTypes = {
    intl: intlShape.isRequired,
    reference: PropTypes.object.isRequired,
    references_has_errored: PropTypes.object.isRequired,
    references_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        references_has_errored: state.references_has_errored,
        references_is_loading: state.references_is_loading,
        reference: state.reference,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Reference)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/reference/Index.js